export const SERVICE_BASE_URL =
  process.env.REACT_APP_SERVICE_BASE_URL;

export const DOCUMENT_URL = process.env.REACT_APP_API_URL;
